export default {
  attachmentTypes: [],
  pagination: {},
  attachmentType: {}
}
